/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_AdjustInputs */

const en_us2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust`)
};

const pt_br2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const es_419_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const pt_pt2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const fr_fr2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster`)
};

const de_de2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

const it_it2_workout_quick_adjust = /** @type {(inputs: Workout_Quick_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

/**
* | output |
* | --- |
* | "Adjust" |
*
* @param {Workout_Quick_AdjustInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_adjust = /** @type {((inputs?: Workout_Quick_AdjustInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_AdjustInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_adjust(inputs)
	if (locale === "es-419") return es_419_workout_quick_adjust(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_adjust(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_adjust(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_adjust(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_adjust(inputs)
	return en_us2_workout_quick_adjust(inputs)
});
export { workout_quick_adjust as "workout-quick.adjust" }